import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from '../../environments/environment.js';

@Injectable({
  providedIn: 'root'
})
export class IndexScriptsService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadScripts(): void {
    if (!environment.production) return;

    const gtmId = 'GTM-PQ2JBXLJ';

    // Inject GTM script
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    this.renderer.appendChild(document.head, script);

    // Inject GTM noscript iframe
    const noscript = this.renderer.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    this.renderer.appendChild(document.body, noscript);
  }
}
